import React, { useEffect, useState } from 'react';
import { downloadReportPdf } from '@src/util/reportPdf/downloadReportPdf';
import { Button, Checkbox, message } from 'antd';
import { useParams } from 'react-router-dom';
import { useLazyQuery, useQuery } from '@apollo/client';
import { getScheduleReportByJobIdQuery } from '@src/util/query/scheduleReport.query';
import { getScheduledJobById } from '@src/util/query/schedule.query';
import { getMobileResponseByIdQuery } from '@src/util/query/mobileResponse.query';
import Spinner from "@src/components/spinner";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { getReportTemplateById } from "@src/util/query/reportTemplate.query";
import { FileFormatTypes } from '@src/util/fileFormatTypes';
import { mapReportDetailToFieldState } from '@src/util/reportFieldAnswers/reportFieldAnswers';
import psgLogo from "./psgLogo.png";

export const PsgAlarmReport = ({checkCallId="", jobId=null, templateId="690b6259851a2cf51d57bb89"})=>{

    const [field, setField] = useState([]);

    const [processingPdf, setPdfProcessing] = useState(false);
    const [reportFields, setReportFields] = useState([]);


    const param = useParams();
    

    const {data, loading} = useQuery(getReportTemplateById,{
        variables:{
            templateId: param?.templateId || templateId
        },
        fetchPolicy:'network-only',
    });


    const {data: reportData, loading: reportDataLoading, refetch: reportDataRefetch} = useQuery(getScheduleReportByJobIdQuery,{
        variables:{
            jobId: param?.jobId || jobId,
            checkCallId
        },
        fetchPolicy:'network-only'
    });

    const activeJobId = param?.jobId || jobId;

    const {data: scheduledJobData, loading: scheduledJobLoading} = useQuery(getScheduledJobById, {
        variables: { jobId: activeJobId },
        skip: !activeJobId,
        fetchPolicy: 'network-only',
    });

    const {data: mobileResponseData, loading: mobileResponseLoading} = useQuery(getMobileResponseByIdQuery, {
        variables: { responseId: activeJobId },
        skip: !activeJobId,
        fetchPolicy: 'network-only',
    });

    const jobDetail = scheduledJobData?.getScheduledJobById?.response || mobileResponseData?.getMobileResponseById?.response || null;
    // dutyTypeDetail or dutyDetail
    // schedule or mobile services
   
   
    useEffect(()=>{
        if(!loading){
            if(
                (reportData?.getScheduleReportByJobId?.response && Object.keys(reportData?.getScheduleReportByJobId?.response)?.length>0)
            ){
                const reportFormData = reportData?.getScheduleReportByJobId?.response?.reportDetail;
                if(reportFormData){
                    const sections = data?.getReportTemplateById?.response?.template?.reportFields;
                    setField(mapReportDetailToFieldState(reportFormData, sections)?.map((f)=>{
                        const reportFormat = f.value?.split?.(".");
                        return {
                            ...f,
                            type: f.value?.includes?.(".")?
                                FileFormatTypes.includes(reportFormat[reportFormat?.length-1])?
                                FileFormatTypes?.find((format)=>format==reportFormat[reportFormat?.length-1])
                                : null : null,
                        };
                    }));
                }


            }
        }
    },[reportData?.getScheduleReportByJobId?.response, loading, data?.getReportTemplateById?.response?.template?.reportFields]);


    useEffect(()=>{
        if(data?.getReportTemplateById?.response?.template?.reportFields && field){

            setReportFields(data?.getReportTemplateById?.response?.template?.reportFields?.map((section)=> {

                    if(!section?.fields?.some((f)=>f?.fieldType=="file")){
                        return section;
                    }

                    return {
                        ...section,
                        fields: section.fields.map((picField)=>{
                            if(picField?.fieldType!=="file"){
                                return picField;
                            }
                            const photos = field?.filter((f)=>f?.name?.startsWith(`${picField.instanceId}_photo`));
                            if(photos?.length===0){
                                return picField;
                            }
                            return photos.map((photoField, index)=>({
                                _id: picField._id,
                                instanceId: photoField.name,
                                parentInstanceId: picField.instanceId,
                                label: "Photo "+(index+1),
                                value: photoField?.value,
                                fieldType: "file",
                                type: photoField?.type,
                                groupId: section.groupId,
                                groupName: section.sectionName,
                            }));
                        }).flat(),
                    };

            }));


        }
    },[data?.getReportTemplateById?.response?.template?.reportFields, field]);
    
   



    // drawn by wfc-server in this layout (utils/pdf/customReports/customReportPdf.ts)
    const downloadPdfFromUrl = async () => {
        setPdfProcessing(true);
        try {
            await downloadReportPdf({ jobId: jobId || param?.jobId, checkCallId, templateId: param?.templateId || templateId, filename: 'PSG report' });
            message.success("Report downloaded successfully");
        } catch (err) {
            message.error(err?.message || "Couldn't create the PDF. Please try again.");
        } finally {
            setPdfProcessing(false);
        }
    };



    return(
    (reportDataLoading || scheduledJobLoading || mobileResponseLoading)?

        <div className='row-flex' style={{justifyContent:'center', alignContent:'center', alignItems:'center'}}>
            <Spinner/>
        </div>
        :


    <div>
                
        <div id="pdfexportBtn" style={{display:'flex', justifyContent:'right', padding:'20px',
            // position: 'sticky',
            // top: '50px',
            // background: 'white',
        }}>
                <Button disabled={processingPdf} style={{fontSize:'14px', borderRadius:'14px'}} onClick={downloadPdfFromUrl}>
                    {processingPdf? 
                        <Spinner/>:
                        <>
                            Download Report &nbsp;<FontAwesomeIcon icon={faDownload} />
                        </>
                    }
                </Button>
        </div>
        <div className='w-wrapper' id="pdfContent" style={{width: "297mm", pageBreakInside: "avoid", margin: '0 auto', maxHeight: "297mm"}}>
            
            
            <div style={{display:'flex', justifyContent:'space-between',  paddingBottom:'20px', marginBottom:'20px', alignItems:'center'}}>
                {( (jobDetail?.dutyTypeDetail?.name || jobDetail?.dutyDetail?.name || reportData?.getScheduleReportByJobId?.response?.reportDetail?.jobtype))?
                    <div style={{
                        fontSize:'28px', 
                        fontWeight:'600', 

                    }}>
                        {jobDetail?.dutyTypeDetail?.name || jobDetail?.dutyDetail?.name || reportData?.getScheduleReportByJobId?.response?.reportDetail?.jobtype} Report
                    </div>
                :null} 
                <img src={psgLogo} width={340} />

            </div>

            {/* Report Fields Sections */}
            {reportFields.map((section, index) => {
                const sectionItems = section?.fields || [];
                const groupName = section?.sectionName || "";

                // Separate photo fields from text fields
                const photoFields = sectionItems.filter(item => 
                    item?.fieldType === 'file'
                );
                
                
                const textFields = sectionItems.filter(item => 
                    item?.fieldType !== 'file'
                );
                
                if(groupName && sectionItems?.length > 0){
                    return(
                        <div key={index} style={{marginBottom:'32px'}}>
                            {/* Section Header */}
                            <div
                            style={{

                                // marginBottom:'16px', 
                                // paddingBottom:'8px', 
                                borderBottom:'2px solid #333',
                                margin:'0 0 16px 0',
                                display:'flex',
                                justifyContent:'space-between',
                                width:'99%'
                                
                            }}
                            >
                                <h2 style={{
                                    fontSize:'16px', 
                                    fontWeight:'600', 
                                }}>
                                    {groupName}

                                    
                                </h2>
                                
                               
                            </div>

                            {/* Text Fields First (if any) */}
                            {textFields.length > 0 && (
                                <div style={{display:'flex', flexDirection:'column', gap:'16px', marginBottom: photoFields.length > 0 ? '24px' : '0'}}>
                                    {textFields.map((prop, itemIndex) => {
                                        const label = prop?.label;
                                        const name = prop?.instanceId;
                                        const {value} = field?.find((f)=>f.name==name) || {value: ""};
                                        
                                        return(
                                            <div key={itemIndex} style={{
                                                padding:'0'
                                            }}>
                                                <div style={{
                                                    fontSize:'14px',
                                                    marginBottom:'8px',
                                                    color:'#000',
                                                    lineHeight:'1.6'
                                                }}>
                                                    {label}
                                                </div>
                                                <div style={{
                                                    background:'#fafafa',
                                                    padding:'10px 14px',
                                                    borderRadius:'4px',
                                                    border:'1px solid #f0f0f0',
                                                    color:'#000',
                                                    fontSize:'14px',
                                                    fontWeight:'500',
                                                    wordBreak:'break-word'
                                                }}>
                                                    {value && value.length > 0 ? value : '---'}
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            )}
                            
                            {/* Photo Fields (if any) */}
                            {photoFields.length > 0 && (
                                <div style={{
                                    display:'flex',
                                    flexWrap:'wrap',
                                    gap:'16px'
                                }}>
                                    {Object.keys(reportData?.getScheduleReportByJobId?.response?.filesURL)?.map((prop, itemIndex) => {

                                        const photoLabel = data?.getReportTemplateById?.response?.template?.reportFields
                                            ?.flatMap((s)=>s?.fields||[])
                                            ?.find((f)=>f.instanceId===prop)?.label || prop;

                                        return(
                                            <div key={itemIndex} style={{
                                                width:'calc(50% - 8px)',
                                                aspectRatio:'16/9',
                                                background:'#f5f5f5',
                                                border:'1px solid #d9d9d9',
                                                borderRadius:'4px',
                                                overflow:'hidden',
                                                position:'relative'
                                            }}>
                                                {reportData?.getScheduleReportByJobId?.response?.filesURL[prop]?.length>0 ? (
                                                    <>
                                                        <img
                                                            src={reportData?.getScheduleReportByJobId?.response?.filesURL[prop]}
                                                            alt={photoLabel}
                                                            style={{
                                                                width:'100%',
                                                                height:'100%',
                                                                objectFit:'cover',
                                                                cursor:'pointer'
                                                            }}
                                                            onClick={()=>window.open(reportData?.getScheduleReportByJobId?.response?.filesURL[prop],"_blank")}
                                                        />
                                                        <div style={{
                                                            position:'absolute',
                                                            bottom:'8px',
                                                            left:'8px',
                                                            background:'rgba(0,0,0,0.7)',
                                                            color:'white',
                                                            padding:'4px 8px',
                                                            borderRadius:'4px',
                                                            fontSize:'12px'
                                                        }}>
                                                            {photoLabel}
                                                        </div>
                                                    </>
                                                ) : (
                                                    <div style={{
                                                        display:'flex',
                                                        alignItems:'center',
                                                        justifyContent:'center',
                                                        height:'100%',
                                                        color:'#999',
                                                        fontSize:'14px',
                                                        textAlign:'center',
                                                        padding:'16px',
                                                        flexDirection:'column'
                                                    }}>
                                                        <div>{photoLabel}</div>
                                                        <div style={{fontSize:'12px', marginTop:'4px'}}>[No image]</div>
                                                    </div>
                                                )}
                                            </div>
                                        )
                                    })}
                                </div>
                            )}
                        </div>
                    )
                }
                return null;
            })}

            {/* Geo-location Section (if exists) */}
            {field?.find(f=>f.name?.includes('geolocation') || f.name?.includes('location')) && (
                <div style={{marginBottom:'32px'}}>
                    <h2 style={{
                        fontSize:'16px',
                        fontWeight:'600',
                        marginBottom:'16px',
                        paddingBottom:'8px',
                        borderBottom:'1px solid #d9d9d9',
                        margin:'0 0 16px 0'
                    }}>
                        Geo-location
                    </h2>
                    <div style={{
                        background:'#f5f5f5',
                        padding:'24px',
                        borderRadius:'4px',
                        border:'1px solid #d9d9d9',
                        textAlign:'center',
                        color:'#999',
                        minHeight:'200px',
                        display:'flex',
                        alignItems:'center',
                        justifyContent:'center'
                    }}>
                        {field?.find(f=>f.name?.includes('geolocation') || f.name?.includes('location'))?.value || '[Map placeholder]'}
                    </div>
                </div>
            )}

            {/* Footer */}
            <div style={{
                marginTop:'48px',
                paddingTop:'16px',
                borderTop:'1px solid #d9d9d9',
                textAlign:'center',
                fontSize:'12px',
                color:'#999'
            }}>
                End of Report
            </div>
        </div>

    </div>
    );
}